import { render, staticRenderFns } from "./LogoInstagramIcon.vue?vue&type=template&id=2f77b40a&"
import script from "./LogoInstagramIcon.vue?vue&type=script&lang=js&"
export * from "./LogoInstagramIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports